// src/pages/auth/ForgetPassword.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { resetPassword } from '../../services/firebase/authService';

function ForgetPassword() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setSuccess(false);

    try {
      const result = await resetPassword(email);
      
      if (!result.success) {
        throw result.error;
      }

      setSuccess(true);
      setEmail(''); // Formu temizle
    } catch (error) {
      console.error('Password reset error:', error);
      if (error.code === 'auth/user-not-found') {
        setError('Bu email adresiyle kayıtlı bir kullanıcı bulunamadı.');
      } else if (error.code === 'auth/invalid-email') {
        setError('Geçersiz email adresi.');
      } else {
        setError('Şifre sıfırlama işlemi sırasında bir hata oluştu. Lütfen daha sonra tekrar deneyin.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0E23] flex items-center justify-center px-4">
      <div className="max-w-md w-full space-y-8 bg-[#151934] p-8 rounded-lg">
        <div>
          <h2 className="text-3xl font-bold text-center text-white mb-2">
            Forgot Password
          </h2>
          <p className="text-center text-gray-400 text-sm">
            Enter your email address and we'll send you a link to reset your password.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="mt-8 space-y-6">
          {error && (
            <div className="bg-red-500/10 text-red-400 text-sm p-3 rounded-lg">
              {error}
            </div>
          )}

          {success && (
            <div className="bg-green-500/10 text-green-400 text-sm p-3 rounded-lg">
              Şifre sıfırlama linki email adresinize gönderildi. Lütfen email'inizi kontrol edin.
            </div>
          )}

          <div>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 bg-gray-800/50 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Email"
              required
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="w-full py-3 px-4 bg-blue-500 hover:bg-blue-600 text-white rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-[#151934] disabled:opacity-50"
          >
            {isLoading ? 'Sending...' : 'Reset Password'}
          </button>

          <div className="text-center">
            <Link to="/login" className="text-blue-500 hover:text-blue-400">
              Back to Login
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ForgetPassword;